<template>
  <div class="history-charge">
    <!-- ========== 搜索条件 ========== -->
    <div class="search-bar">
      <el-form :model="searchForm" label-width="80px" size="mini" inline>
        <el-form-item label="收费单号:">
          <el-input
              v-model="searchForm.chargeNo"
              placeholder="请输入收费单号"
              clearable
              style="width:180px;"
              @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        <el-form-item label="患者姓名:">
          <el-input
              v-model="searchForm.patientName"
              placeholder="请输入患者姓名"
              clearable
              style="width:140px;"
              @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        <el-form-item label="收费类型:">
          <el-select
              v-model="searchForm.chargeType"
              placeholder="全部"
              clearable
              style="width:140px;"
              @change="handleSearch"
          >
            <el-option label="预约挂号收费" :value="1" />
            <el-option label="处方订单收费" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="收费状态:">
          <el-select
              v-model="searchForm.status"
              placeholder="全部"
              clearable
              style="width:120px;"
              @change="handleSearch"
          >
            <el-option label="已收费" :value="1" />
            <el-option label="部分退款" :value="2" />
            <el-option label="全额退款" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="收费时间:">
          <el-date-picker
              v-model="searchForm.timeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              style="width:360px;"
              @change="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <el-button size="mini" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>    </div>

    <!-- ========== 主表格 ========== -->
    <div class="table-container">
      <el-table
          ref="mainTable"
          :data="tableData"
          border
          highlight-current-row
          height="calc(100vh - 320px)"
          @row-dblclick="handleRowClick"
          v-loading="loading"
      >
        <el-table-column fixed="left" label="行号" type="index" width="50" align="center" />
        <el-table-column prop="chargeNo" label="收费单号" min-width="180" align="center" show-overflow-tooltip />
        <el-table-column prop="patientName" label="患者姓名" width="100" align="center" />
        <el-table-column prop="chargeType" label="收费类型" width="130" align="center">
          <template #default="{ row }">
            <el-tag :type="row.chargeType === 1 ? 'primary' : 'success'" size="mini">
              {{ row.chargeType === 1 ? '预约挂号收费' : '处方订单收费' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="原价总金额" width="120" align="center">
          <template #default="{ row }">
            ¥{{ row.totalAmount?.toFixed(2) || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="paidAmount" label="实付总金额" width="120" align="center">
          <template #default="{ row }">
            <span style="color: #67C23A; font-weight: bold;">¥{{ row.paidAmount?.toFixed(2) || '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="netAmount" label="当前净收金额" width="130" align="center">
          <template #default="{ row }">
            <span style="color: #409EFF; font-weight: bold;">¥{{ row.netAmount?.toFixed(2) || '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="refundedAmount" label="已退款总金额" width="130" align="center">
          <template #default="{ row }">
            <span style="color: #F56C6C;">¥{{ row.refundedAmount?.toFixed(2) || '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="收费状态" width="100" align="center">
          <template #default="{ row }">
            <el-tag :type="getStatusType(row.status)" size="mini">
              {{ getStatusLabel(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="chargeTime" label="收费时间" min-width="160" align="center">
          <template #default="{ row }">
            {{ row.chargeTime ? dayjs(row.chargeTime).format('YYYY-MM-DD HH:mm:ss') : '-' }}
          </template>
        </el-table-column>

        <!-- ===== 操作列 ===== -->
        <el-table-column fixed="right" label="操作" width="160" align="center">
          <template #default="{ row }">
            <el-button
                v-if="row.chargeStatus === 0"
                type="danger"
                size="mini"
                @click.stop="handleCancelOrder(row)"
            >
              作废
            </el-button>
            <el-button
                v-else-if="row.status !== 3"
                type="warning"
                size="mini"
                @click.stop="handleRowClick(row)"
            >
              退费
            </el-button>
            <span v-else style="color:#C0C4CC; font-size:12px;">已全退</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- ========== 分页 ========== -->
    <div class="pagination-container">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="totalSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
      />
    </div>

    <!-- ============================================================ -->
    <!-- ========== 详情弹窗 ========== -->
    <!-- ============================================================ -->
    <el-dialog
        title="收费详情"
        :visible.sync="detailDialogVisible"
        width="80%"
        :close-on-click-modal="false"
        class="detail-dialog"
        @closed="handleDetailClosed"
    >
      <div v-loading="detailLoading" class="detail-layout">
        <!-- 顶部基本信息 -->
        <div class="detail-header">
          <el-form size="mini" label-width="70px" disabled>
            <el-row :gutter="16">
              <el-col :span="4">
                <el-form-item label="收费单号:">
                  <el-input v-model="detailData.chargeNo" />
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="患者:">
                  <el-input v-model="detailData.patientName" />
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="状态:">
                  <el-tag :type="getStatusType(detailData.status)" size="mini">
                    {{ getStatusLabel(detailData.status) }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="收费时间:">
                  <el-input :value="detailData.chargeTime ? dayjs(detailData.chargeTime).format('YYYY-MM-DD HH:mm:ss') : '-'" />
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="可退总额:">
                  <el-input :value="'¥' + (detailData.refundableAmount?.toFixed(2) || '0.00')" style="color:#409EFF; font-weight:bold;" />
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item label="已退:">
                  <el-input :value="'¥' + (detailData.refundedAmount?.toFixed(2) || '0.00')" style="color:#F56C6C;" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <!-- 左右内容 -->
        <div class="detail-body">
          <!-- ========== 左侧：项目明细 ========== -->
          <div class="detail-left">
<!--            <div class="panel-title">
&lt;!&ndash;              <span v-if="hasInvalidSelection" style="font-size:12px; color:#F56C6C; margin-left:12px;">
        ⚠️ 存在已执行西药，不可退款
      </span>&ndash;&gt;
            </div>-->

            <!-- 1. 中药处方 -->
            <!-- 1. 中药处方 -->
            <template v-if="prescriptionType === 'tcm'">
              <div class="tcm-refund-area">
                <el-form size="small" label-width="140px" style="width:100%;">

                  <!-- ===== 总付数（固定） ===== -->
                  <el-form-item label="总付数：">
        <span style="font-weight:bold; font-size:16px; color:#409EFF;">
          {{ tcmTotalPacks }} 付（{{ tcmTotalQty }}{{ tcmUnit }}）
        </span>
                  </el-form-item>

                  <!-- ===== 已退药付数（从 returnItems 累加） ===== -->
                  <el-form-item label="已退药付数：">
        <span style="font-weight:bold; font-size:16px; color:#E6A23C;">
          {{ tcmReturnedPacks }} 付
        </span>
                  </el-form-item>

                  <!-- ===== 可退药付数（总付数 - 已退药付数） ===== -->
                  <el-form-item label="可退药付数：">
        <span style="font-weight:bold; font-size:16px; color:#67C23A;">
          {{ tcmRefundableReturnPacks }} 付
        </span>
                  </el-form-item>

                  <!-- ===== 已退费付数（refundedQty 换算） ===== -->
                  <el-form-item label="已退费付数：">
        <span style="font-weight:bold; font-size:16px; color:#F56C6C;">
          {{ tcmRefundedPacks }} 付
        </span>
                  </el-form-item>

                  <!-- ===== 可退费付数（refundableQty 换算） ===== -->
                  <el-form-item label="可退费付数：">
        <span style="font-weight:bold; font-size:16px; color:#409EFF;">
          {{ tcmRefundablePacks }} 付
        </span>
                  </el-form-item>

                  <!-- ===== 本次退药付数（用户输入，用于退药） ===== -->
                  <el-form-item label="本次退药付数：">
                    <el-input-number
                        v-model="tcmRefundQty"
                        :min="0"
                        :max="tcmRefundableReturnPacks"
                        :step="1"
                        controls-position="right"
                        style="width:150px;"
                    />
                    <el-button size="small" style="margin-left:10px;" @click="tcmRefundQty = tcmRefundableReturnPacks">
                      全退
                    </el-button>
                    <span style="margin-left:10px; font-size:12px; color:#909399;">
          共 {{ tcmItemCount }} 味药
        </span>
                  </el-form-item>

                  <!-- 退药方式 -->
                  <el-form-item label="退药方式：">
                    <el-radio-group v-model="tcmDisposalMethod">
                      <el-radio label="RETURN">入库退回</el-radio>
                      <el-radio label="DESTROY">销毁退回（默认）</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <!-- 药味明细 -->
                  <el-form-item label=" " label-width="20px">
                    <el-collapse v-model="activeTcmCollapse" style="width:100%; border:none;">
                      <el-collapse-item name="tcmDetail" style="border:none;">
                        <template slot="title">
              <span style="font-size:13px; color:#409EFF; user-select:none;">
                📋 查看药味明细（{{ drugItems.length }} 味）
              </span>
                        </template>
                        <el-table
                            :data="drugItems"
                            border
                            size="mini"
                            max-height="200"
                            style="width:100%;"
                        >
                          <el-table-column prop="itemName" label="药品名称" min-width="120" show-overflow-tooltip />
                          <el-table-column prop="specification" label="规格" min-width="120" show-overflow-tooltip />
                          <el-table-column label="单价" width="80" align="center">
                            <template #default="{ row }">
                              ¥{{ (row.paidAmount / row.chargedQty || 0).toFixed(2) }}
                            </template>
                          </el-table-column>
                          <el-table-column prop="chargedQty" label="数量" width="70" align="center" />
                          <el-table-column prop="unitName" label="单位" width="60" align="center" />
                          <el-table-column prop="executedQty" label="已执行" width="70" align="center">
                            <template #default="{ row }">
                              {{ row.executedQty || 0 }}
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-collapse-item>
                    </el-collapse>
                  </el-form-item>

                </el-form>
              </div>
            </template>
            <!-- 2. 纯处置处方 -->
            <template v-if="prescriptionType === 'treatment'">
              <div class="drug-table-wrap">
                <el-table
                    ref="treatmentTable"
                    :data="treatmentItems"
                    border
                    @selection-change="handleTreatmentSelectionChange"
                    row-key="chargeItemId"
                    style="width: 100%;"
                >
                  <el-table-column type="selection" width="55" align="center" :selectable="checkTreatmentSelectable" />
                  <el-table-column label="项目名称" min-width="140" align="center" show-overflow-tooltip>
                    <template #default="{ row }">{{ row.itemName }}</template>
                  </el-table-column>
                  <el-table-column prop="specification" label="规格" min-width="100" align="center" />
                  <el-table-column prop="unitName" label="单位" width="60" align="center" />
                  <el-table-column prop="chargedQty" label="总数量" width="80" align="center" />
                  <el-table-column prop="executedQty" label="已执行数" width="90" align="center">
                    <template #default="{ row }">
                      <span v-if="row.executeMode === 1">{{ row.executedQty || 0 }}</span>
                      <span v-else style="color:#C0C4CC;">-</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="refundableQty" label="可退数量" width="90" align="center">
                    <template #default="{ row }">
                      <span style="color:#409EFF; font-weight:bold;">{{ row.refundableQty || 0 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="状态" width="80" align="center">
                    <template #default="{ row }">
                      <el-tag v-if="row.refundableQty === 0" type="danger" size="mini">已执行完</el-tag>
                      <el-tag v-else-if="row.refundedQty > 0" type="warning" size="mini">部分退</el-tag>
                      <el-tag v-else type="success" size="mini">可退</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>

            <!-- 3. 纯西药 / 纯输液 处方 -->
            <template v-if="['western', 'infusion'].includes(prescriptionType)">
              <div class="drug-table-wrap">
                <el-table
                    ref="drugTable"
                    :data="drugItems"
                    border
                    @row-dblclick="getDrugItemsDetail"
                    @selection-change="handleDrugSelectionChange"
                    row-key="chargeItemId"
                    :expand-row-keys="drugReturnExpand"
                    @expand-change="handleDrugExpandChange"
                    style="width: 100%;"
                >
                  <!-- 展开列 -->
                  <el-table-column type="expand" width="50">
                    <template #default="{ row }">
                      <div class="drug-expand-content">
                        <div v-if="row.returnItems && row.returnItems.length > 0" class="return-table-wrap">
                          <el-table :data="row.returnItems" border size="mini" style="width: 100%;">
                            <el-table-column label="退药单号" prop="drugReturnId" width="120" align="center" />
                            <el-table-column label="退药数量" prop="returnQty" width="100" align="center">
                              <template #default="{ row: returnRow }">
                                <span style="color:#E6A23C; font-weight:bold;">{{ returnRow.returnQty || 0 }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column label="单位" prop="unitName" width="100" align="center" />

                            <el-table-column label="退药时间" prop="returnedAt" min-width="160" align="center">
                              <template #default="{ row: returnRow }">
                                {{ returnRow.returnedAt ? dayjs(returnRow.returnedAt).format('YYYY-MM-DD HH:mm:ss') : '-' }}
                              </template>
                            </el-table-column>
                          </el-table>
                        </div>
                        <div v-else class="empty-return-tip">暂无退药记录</div>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column type="selection" width="55" align="center" :selectable="checkDrugSelectable" />
                  <el-table-column label="药品名称" min-width="140" align="center" show-overflow-tooltip>
                    <template #default="{ row }">{{ row.itemName }}</template>
                  </el-table-column>
                  <el-table-column prop="specification" label="规格" min-width="100" align="center" />
                  <el-table-column prop="unitName" label="单位" width="60" align="center" />
                  <el-table-column prop="chargedQty" label="总数量" width="80" align="center" />
                  <el-table-column prop="refundedQty" label="已退款数量" width="100" align="center">
                    <template #default="{ row }">
                      <span style="color:#F56C6C;">{{ row.refundedQty || 0 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="已退药数量" width="100" align="center">
                    <template #default="{ row }">
                      <span style="color:#E6A23C; font-weight:bold;">{{ getReturnTotal(row.returnItems) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="可退数量" width="90" align="center">
                    <template #default="{ row }">
                      <span style="color:#409EFF; font-weight:bold;">{{ getActualRefundableQty(row) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="prescriptionType === 'infusion'" prop="executedQty" label="执行情况" width="120" align="center">
                    <template #default="{ row }">
              <span v-if="row.executedQty > 0" style="color:#F56C6C;">
                已执行 {{ row.executedQty }}/{{ row.chargedQty }}
              </span>
                      <span v-else style="color:#67C23A;">未执行</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="状态" width="80" align="center">
                    <template #default="{ row }">
                      <el-tag v-if="getActualRefundableQty(row) === 0" type="danger" size="mini">已全退</el-tag>
                      <el-tag v-else-if="row.refundedQty > 0" type="warning" size="mini">部分退</el-tag>
                      <el-tag v-else type="success" size="mini">可退</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <!-- 退药方式 -->
              <div style="padding:8px 12px; background:#f8f9fa; border-top:1px solid #e8ecf1;">
                <el-form size="small" inline>
                  <el-form-item label="退药方式：">
                    <el-radio-group v-model="drugDisposalMethod">
                      <el-radio label="RETURN">入库退回（默认）</el-radio>
                      <el-radio label="DESTROY">销毁退回</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-form>
              </div>
            </template>


            <!-- 4. 混合处方：使用 Tabs 切换展示 -->
            <!-- 4. 混合处方：Tabs 切换展示 -->
            <template v-if="prescriptionType === 'mixed'">
              <!-- 退药方式 - 放在 tabs 外部 -->
              <div style="display: flex; align-items: center; justify-content: space-between; padding: 4px 12px 8px 12px; background: #f8f9fa; border-bottom: 1px solid #e8ecf1; flex-shrink: 0;">
                <div style="display: flex; align-items: center; gap: 16px;">
                  <span style="font-size:13px; color:#303133; font-weight:500;">退药方式：</span>
                  <el-radio-group v-model="drugDisposalMethod" size="mini">
                    <el-radio label="RETURN">入库退回（默认）</el-radio>
                    <el-radio label="DESTROY">销毁退回</el-radio>
                  </el-radio-group>
                </div>
                <span style="font-size:13px; color:#303133;">
      可退合计：<span style="color:#409EFF; font-weight:bold; font-size:16px;">¥{{ getTotalRefundableAmount().toFixed(2) }}</span>
    </span>
              </div>

              <!-- Tabs: 只负责切换 -->
              <el-tabs v-model="mixedActiveTab" type="card" class="mixed-tabs">
                <!-- ===== Tab1: 药品 ===== -->
                <el-tab-pane label="药品" name="drug">
                  <el-table
                      ref="mixedDrugTable"
                      :data="drugItems"
                      border
                      :height="tableHeight"
                      @row-dblclick="getDrugItemsDetail"
                      @selection-change="handleMixedDrugSelectionChange"
                      row-key="chargeItemId"
                      :expand-row-keys="drugReturnExpand"
                      @expand-change="handleDrugExpandChange"
                  >
                    <!-- 展开列 -->
                    <el-table-column type="expand" width="50">
                      <template #default="{ row }">
                        <div class="drug-expand-content">
                          <div v-if="row.returnItems && row.returnItems.length > 0" class="return-table-wrap">
                            <el-table :data="row.returnItems" border size="mini" style="width:100%;">
                              <el-table-column label="退药单号" prop="drugReturnId" width="120" align="center" />
                              <el-table-column label="退药数量" prop="returnQty" width="100" align="center">
                                <template #default="{ row: returnRow }">
                                  <span style="color:#E6A23C; font-weight:bold;">{{ returnRow.returnQty || 0 }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column label="退药时间" prop="returnedAt" min-width="160" align="center">
                                <template #default="{ row: returnRow }">
                                  {{ returnRow.returnedAt ? dayjs(returnRow.returnedAt).format('YYYY-MM-DD HH:mm:ss') : '-' }}
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                          <div v-else class="empty-return-tip">暂无退药记录</div>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column type="selection" width="55" align="center" :selectable="checkDrugSelectable" />
                    <el-table-column label="药品名称" min-width="140" align="center" show-overflow-tooltip>
                      <template #default="{ row }">{{ row.itemName }}</template>
                    </el-table-column>
                    <el-table-column prop="specification" label="规格" min-width="100" align="center" />
                    <el-table-column prop="unitName" label="单位" width="60" align="center" />
                    <el-table-column prop="chargedQty" label="总数量" width="80" align="center" />
                    <el-table-column prop="refundedQty" label="已退款数量" width="100" align="center">
                      <template #default="{ row }">
                        <span style="color:#F56C6C;">{{ row.refundedQty || 0 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="已退药数量" width="100" align="center">
                      <template #default="{ row }">
                        <span style="color:#E6A23C; font-weight:bold;">{{ getReturnTotal(row.returnItems) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="可退数量" width="90" align="center">
                      <template #default="{ row }">
                        <span style="color:#409EFF; font-weight:bold;">{{ getActualRefundableQty(row) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="状态" width="80" align="center">
                      <template #default="{ row }">
                        <el-tag v-if="getActualRefundableQty(row) === 0" type="danger" size="mini">已全退</el-tag>
                        <el-tag v-else-if="row.refundedQty > 0" type="warning" size="mini">部分退</el-tag>
                        <el-tag v-else type="success" size="mini">可退</el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>

                <!-- ===== Tab2: 处置 ===== -->
                <el-tab-pane label="处置" name="treatment">
                  <el-table
                      ref="mixedTreatmentTable"
                      :data="treatmentItems"
                      border
                      :height="tableHeight"
                      @selection-change="handleMixedTreatmentSelectionChange"
                      row-key="chargeItemId"
                  >
                    <el-table-column type="selection" width="55" align="center" :selectable="checkMixedTreatmentSelectable" />
                    <el-table-column label="项目名称" min-width="140" align="center" show-overflow-tooltip>
                      <template #default="{ row }">{{ row.itemName }}</template>
                    </el-table-column>
                    <el-table-column prop="specification" label="规格" min-width="100" align="center" />
                    <el-table-column prop="unitName" label="单位" width="60" align="center" />
                    <el-table-column prop="chargedQty" label="总数量" width="80" align="center" />
                    <el-table-column prop="executedQty" label="已执行数" width="90" align="center">
                      <template #default="{ row }">
                        <span v-if="row.executeMode === 1">{{ row.executedQty || 0 }}</span>
                        <span v-else style="color:#C0C4CC;">-</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="refundableQty" label="可退数量" width="90" align="center">
                      <template #default="{ row }">
                        <span style="color:#409EFF; font-weight:bold;">{{ row.refundableQty || 0 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="状态" width="80" align="center">
                      <template #default="{ row }">
                        <el-tag v-if="row.refundableQty === 0" type="danger" size="mini">已执行完</el-tag>
                        <el-tag v-else-if="row.refundedQty > 0" type="warning" size="mini">部分退</el-tag>
                        <el-tag v-else type="success" size="mini">可退</el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </template>          <!-- 5. 其他（兜底） -->
            <template v-if="prescriptionType === 'other'">
              <el-table
                  ref="itemTable"
                  :data="detailData.items || []"
                  border
                  @selection-change="handleItemSelectionChange"
                  @row-click="handleItemRowClick"
                  row-key="chargeItemId"
                  style="width: 100%;"
              >
                <el-table-column type="selection" width="55" align="center" :selectable="checkSelectable" />
                <el-table-column prop="itemName" label="项目名称" min-width="160" align="center" show-overflow-tooltip />
                <el-table-column prop="specification" label="规格" min-width="100" align="center" show-overflow-tooltip />
                <el-table-column prop="itemType" label="类型" width="80" align="center">
                  <template #default="{ row }">
                    {{ getItemTypeLabel(row.itemType) }}
                  </template>
                </el-table-column>
                <el-table-column prop="unitName" label="单位" width="60" align="center" />
                <el-table-column prop="chargedQty" label="收费数量" width="80" align="center" />
                <el-table-column prop="refundableQty" label="可退数量" width="80" align="center">
                  <template #default="{ row }">
                    <span style="color:#409EFF; font-weight:bold;">{{ row.refundableQty || 0 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="paidAmount" label="实付金额" width="100" align="center">
                  <template #default="{ row }">
                    <span style="color:#67C23A; font-weight:bold;">¥{{ row.paidAmount?.toFixed(2) || '0.00' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="refundedAmount" label="已退金额" width="100" align="center">
                  <template #default="{ row }">
                    <span style="color:#F56C6C;">¥{{ row.refundedAmount?.toFixed(2) || '0.00' }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>


          </div>

          <!-- ========== 右侧：批次/追溯码明细 ========== -->
          <div class="detail-right">
            <div class="panel-title">
              <span>批次/追溯码明细</span>
              <span v-if="selectedDrugName" style="font-size:12px; color:#409EFF; margin-left:10px;">
        {{ selectedDrugName }}
      </span>
              <span v-else style="font-size:12px; color:#C0C4CC; margin-left:10px;">
        （请双击左侧已发药药品查看批次明细）
      </span>
              <el-button
                  type="danger"
                  size="mini"
                  plain
                  style="margin-left:auto;"
                  :disabled="batchDetailData.length === 0 || batchDetailData.every(item => !item.keReturnCnt || item.keReturnCnt <= 0)"
                  @click="handleBatchReturnAll"
              >
                全退
              </el-button>
            </div>

            <div class="batch-table-wrapper">
              <el-table
                  ref="batchTable"
                  :data="batchDetailData"
                  border
                  v-loading="batchLoading"
                  element-loading-text="加载批次信息..."
                  style="height: 100%; width: 100%;"
                  row-key="dispenseItemId"
                  :expand-row-keys="expandRowKeys"
              >
                <!-- 展开列 -->
                <el-table-column type="expand" width="50">
                  <template #default="{ row }">
                    <div class="expand-content">
                      <div v-if="row.barList && row.barList.length > 0" class="bar-table-wrap">
                        <el-table
                            :data="row.selectedBars"
                            border
                            size="mini"
                            style="width: 100%;"
                            @selection-change="(selection) => handleBarSelectionChange(row, selection)"
                        >
                          <el-table-column type="selection" width="40" align="center"
                                           :selectable="(bar) => checkBarSelectable(row, bar)" />
                          <el-table-column label="追溯码" prop="barcode" min-width="100" align="center" show-overflow-tooltip />
                          <el-table-column label="出库数量" prop="outCnt" min-width="100" align="center" />
                          <el-table-column label="已退数量" prop="backCnt" min-width="100" align="center" />
                        </el-table>
                      </div>
                      <div v-else class="empty-bar-tip">暂无追溯码</div>
                    </div>
                  </template>
                </el-table-column>

                <!-- 退药数量列（可编辑） -->
                <el-table-column label="退药数量" width="120" align="center">
                  <template #default="{ row }">
                    <el-input-number
                        v-model="row.returnCnt"
                        :min="0"
                        :max="row.keReturnCnt || 0"
                        :step="1"
                        size="mini"
                        controls-position="right"
                        style="width:110px;"
                        placeholder="0"
                        @change="handleReturnCntChange(row)"
                    />
                  </template>
                </el-table-column>


                <el-table-column label="已退数量" prop="yiReturnCnt" width="100" align="center">
                  <template #default="{ row }">
                    <span style="color:#F56C6C;">{{ row.yiReturnCnt || 0 }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="单位" width="80" align="center">
                  <template #default="{ row }">
                    <span v-if="row.unitId === row.minUntId">{{ row.minUntName }}</span>
                    <span v-else-if="row.unitId === row.pacUntId">{{ row.pacUntName }}</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="包装" width="120" align="center">
                  <template #default="{ row }">
                    {{ row.pacCnt || 0 }}{{ row.pacUntName || '' }}/{{ row.minUntName || '' }}
                  </template>
                </el-table-column>
                <el-table-column label="追溯码" width="100" align="center">
                  <template #default="{ row }">
                    <el-tag v-if="row.barList && row.barList.length > 0" size="mini" type="info">
                      {{ row.barList.length }}个
                    </el-tag>
                    <span v-else style="color:#C0C4CC;">-</span>
                  </template>
                </el-table-column>
                <el-table-column label="生产批号" prop="manuLotnum" min-width="150" align="center" show-overflow-tooltip />
                <el-table-column label="生产厂家" prop="prodentpName" min-width="180" align="center" show-overflow-tooltip />
                <el-table-column label="生产日期" prop="manuDate" width="120" align="center">
                  <template #default="{ row }">
                    {{ row.manuDate ? dayjs(row.manuDate).format('YYYY-MM-DD') : '-' }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="common-return-bar">
          <el-form size="small" inline>
            <el-form-item label="退药方式：">
              <el-radio-group v-model="returnType">
                <el-radio :label="1">退药入库</el-radio>
                <el-radio :label="2">报损不入库</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="退药原因：">
              <el-input
                  v-model="returnReason"
                  placeholder="请输入退药原因"
                  size="small"
                  style="width:200px;"
                  maxlength="200"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                  type="primary"
                  size="small"
                  :loading="returnSubmitting"
                  @click="handleSubmitReturnDrug"
              >
                提交退药
              </el-button>
              <el-button
                  type="danger"
                  size="small"
                  :loading="returnAllSubmitting"
                  :disabled="drugItems.length === 0"
                  @click="handleReturnAll"
              >
                全退
              </el-button>
              <el-divider direction="vertical" />
              <el-button
                  type="danger"
                  size="small"
                  @click="handleOpenRefundDialog"
              >
                退款
              </el-button>
            </el-form-item>
          </el-form>
        </div>      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false" size="mini">关闭</el-button>
      </span>
    </el-dialog>

    <!-- ============================================================ -->
    <!-- ========== 退款弹窗 ========== -->
    <!-- ============================================================ -->
    <el-dialog
        title="退款"
        :visible.sync="refundDialogVisible"
        width="75%"
        :close-on-click-modal="false"
        class="refund-dialog"
        @closed="handleRefundDialogClosed"
    >
      <div class="refund-content">
        <div style="margin-bottom:15px;">
          <div style="font-weight:bold; margin-bottom:8px; font-size:14px;">退款项目</div>
          <el-table :data="refundItems" border size="mini" max-height="220">
            <el-table-column prop="itemName" label="项目名称" min-width="150" align="center" show-overflow-tooltip />
            <el-table-column prop="specification" label="规格" min-width="100" align="center" />
            <el-table-column prop="unitName" label="单位" width="60" align="center" />
            <el-table-column prop="chargedQty" label="收费数量" width="80" align="center" />
            <el-table-column prop="refundableQty" label="可退数量" width="90" align="center">
              <template #default="{ row }">
                <span style="color:#409EFF; font-weight:bold;">{{ row.refundableQty }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="refundQty" label="退款数量" width="140" align="center">
            </el-table-column>
            <el-table-column prop="refundAmount" label="退款金额" width="120" align="center">
              <template #default="{ row }">
                <span style="color:#F56C6C; font-weight:bold;">¥{{ row.refundAmount?.toFixed(2) || '0.00' }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="margin-bottom:15px;">
          <div style="font-weight:bold; margin-bottom:8px; font-size:14px;">退款支付方式</div>
          <el-form size="mini" label-width="100px">
            <el-row :gutter="20" v-for="(group, idx) in refundPaymentGroups" :key="idx">
              <el-col :span="8" v-for="payment in group" :key="payment.originalPaymentId">
                <el-form-item :label="getPayWayLabel(payment.payWayId) + ':'">
                  <el-input-number
                      v-model="payment.refundAmount"
                      :min="0"
                      :max="payment.refundableAmount"
                      :precision="2"
                      :step="0.01"
                      size="mini"
                      controls-position="right"
                      style="width:130px;"
                      @change="handlePaymentRefundChange"
                  />
                  <span style="margin-left:6px; font-size:12px; color:#909399;">/ ¥{{ payment.refundableAmount?.toFixed(2) }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="text-align:right; padding-right:20px; margin-top:5px;">
            退款合计：<span style="color:#F56C6C; font-weight:bold; font-size:18px;">¥{{ getRefundTotal().toFixed(2) }}</span>
          </div>
        </div>

        <el-form label-width="100px" size="mini">
          <el-form-item label="退款原因:">
            <el-input
                v-model="refundReason"
                type="textarea"
                :rows="3"
                placeholder="请输入退款原因"
                maxlength="200"
                show-word-limit
                style="width:70%;"
            />
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="refundDialogVisible = false" size="mini">取消</el-button>
        <el-button type="danger" size="mini" @click="handleConfirmRefund" :loading="refundLoading">确认退款</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getChargesQuery,
  getRefundableCharges,
  chargesRefunds,
  cancelOrderById, getReturnDrugDetail, submitReturnDrugDetail, submitReturnDrugDetailAll, submitReturnDrugDetailTcm
} from '@/api/reservation/outpatientChargeV2';
import { getPatternPaymentList } from '@/api/patternPayment/patternPayment';
import dayjs from 'dayjs';

export default {
  name: 'HistoryCharge',
  data() {
    return {
      currentSelectedDrug:null,
      batchDetailCache: {},          // 缓存所有药品的批次数据，key: orderItemId
      currentOrderItemId: null,      // 当前显示的 orderItemId
      tcmTotalQty: 0,                // 总数量（g）
      tcmUnit: 'g',                  // 单位
      tcmReturnedPacks: 0,           // 已退药付数（从 returnItems 累加）
      tcmRefundableReturnPacks: 0,   // 可退药付数（总付数 - 已退药付数）
      mixedActiveTab: 'drug',
      tableHeight: 400,            // 表格高度
      tcmItemsData: [],
      returnAllSubmitting: false,
      drugReturnExpand: [],      // ===== 批次退药 =====
      returnReason: '',           // 退药原因
      returnType: 1,              // 退药类型：1退药入库，2报损不入库
      returnSubmitting: false,    // 提交加载状态
      selectedOrderId: null,      // 当前退药的订单ID
      expandRowKeys: [],
      batchDetailData: [],        // 批次明细数据
      selectedDrugName: '',       // 当前选中的药品名称
      selectedOrderItemId: null,  // 当前选中的订单明细ID
      batchLoading: false,        // 加载状态
      activeTcmCollapse: [],
      searchForm: {
        chargeNo: '',
        patientName: '',
        chargeType: null,
        status: null,
        timeRange: [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ]
      },
      tableData: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      totalSize: 0,

      detailDialogVisible: false,
      detailLoading: false,
      detailData: {
        chargeId: null,
        chargeNo: '',
        patientName: '',
        chargeTime: '',
        status: null,
        refundableAmount: 0,
        refundedAmount: 0,
        items: [],
        payments: []
      },
      selectedItems: [],
      paymentMethods: [],

      prescriptionType: 'other',
      treatmentItems: [],
      drugItems: [],

      tcmTotalPacks: 0,
      tcmRefundedPacks: 0,
      tcmRefundablePacks: 0,
      tcmRefundQty: 0,
      tcmRefundAmount: 0,
      tcmItemCount: 0,
      tcmDisposalMethod: 'DESTROY',

      drugDisposalMethod: 'RETURN',

      refundDialogVisible: false,
      refundItems: [],
      refundPayments: [],
      refundReason: '',
      refundLoading: false,

      dayjs
    };
  },

  computed: {
    refundPaymentGroups() {
      const rows = [];
      for (let i = 0; i < this.refundPayments.length; i += 3) {
        rows.push(this.refundPayments.slice(i, i + 3));
      }
      return rows;
    },

    hasInvalidSelection() {
      return this.selectedItems.some(item =>
          item.executedQty >= 1 && item.itemType === 1
      );
    },

    canRefund() {
      if (this.prescriptionType === 'tcm') {
        // 可以退款的条件：已退药付数 > 0 且 本次退药数量 > 0
        // 或者只要已退药付数 > 0 就可以退款
        return this.tcmReturnedPacks > 0;
      }
      return this.selectedItems.length > 0 && !this.hasInvalidSelection;
    }
  },

  mounted() {
    this.loadPaymentMethods();
    this.handleSearch();
    this.$nextTick(() => {
      this.calcTableHeight();
    });
  },

  methods: {
    checkBarSelectable(row, bar) {
      const limit = row.returnCnt || 0;
      if (limit <= 0) return false;

      // 当前已勾选的数量（不包括当前这个 bar，因为它是待判定的）
      const currentCheckedCount = row.selectedBars.filter(b => b.checked).length;
      // 如果当前 bar 已经勾选，允许取消勾选，但允许勾选的条件是已勾选数量 < limit
      if (bar.checked) return true; // 已勾选的允许取消（但这里selectable是控制能否被选中，取消不影响）
      return currentCheckedCount < limit;
    },
    // ===== 批次/追溯码全退：所有批次退药数量全部填满 =====
    handleBatchReturnAll() {
      if (this.batchDetailData.length === 0) {
        this.$message.warning('暂无批次数据');
        return;
      }
      this.batchDetailData.forEach(item => {
        // 设置退药数量为可退数量
        item.returnCnt = item.keReturnCnt || 0;
        // 勾选所有追溯码（如果追溯码数量超过 returnCnt，只勾选前 returnCnt 个）
        if (item.barList && item.barList.length > 0) {
          const limit = item.returnCnt;
          item.barList.forEach((bar, index) => {
            bar.checked = index < limit;
          });
          item.selectedBars = item.barList.map(bar => ({ ...bar }));
        }
      });
      this.$message.success('全退设置成功');
    },
    calcTableHeight() {
      // 弹窗高度 65vh，减去顶部信息、标题、操作栏等
      this.tableHeight = window.innerHeight * 0.65 - 180;
      if (this.tableHeight < 200) this.tableHeight = 200;
    },
    // ===== 混合处方 - 药品表格选择变化 =====
    handleMixedDrugSelectionChange(selection) {
      const treatmentSelection = this.$refs.mixedTreatmentTable ? this.$refs.mixedTreatmentTable.selection : [];
      this.selectedItems = [...treatmentSelection, ...selection];
    },

// ===== 混合处方 - 处置表格选择变化 =====
    handleMixedTreatmentSelectionChange(selection) {
      const drugSelection = this.$refs.mixedDrugTable ? this.$refs.mixedDrugTable.selection : [];
      this.selectedItems = [...drugSelection, ...selection];
    },

// ===== 混合处方 - 处置可选择性 =====
    checkMixedTreatmentSelectable(row) {
      return (row.refundableQty || 0) > 0 && (row.refundableAmount || 0) > 0;
    },
    // ===== 退药数量变化 =====
    handleReturnCntChange(row) {
      const limit = row.returnCnt || 0;
      const checkedBars = row.selectedBars.filter(bar => bar.checked);
      if (checkedBars.length > limit) {
        // 取消超出的勾选
        const surplus = checkedBars.slice(limit);
        surplus.forEach(bar => bar.checked = false);
        // 更新 selectedBars 的引用以触发渲染
        row.selectedBars = row.selectedBars.map(bar => ({ ...bar }));
        this.$message.warning(`退药数量改为 ${limit}，已自动取消多余的勾选`);
      }
    },
    // ===== 混合处方选择变化 =====
    handleMixedSelectionChange(selection) {
      this.selectedItems = selection;
    },

// ===== 混合处方可选择性 =====
    checkMixedSelectable(row) {
      // 已执行西药不可选
      if (row.executeMode === 1 && row.itemType === 1) return false;
      // 处置项目
      if ([4, 5, 7, 8].includes(row.itemType)) {
        return (row.refundableQty || 0) > 0 && (row.refundableAmount || 0) > 0;
      }
      // 药品
      return (row.refundableAmount || 0) > 0;
    },

// ===== 全退 =====
    async handleReturnAll() {
      // 1. 校验是否有药品数据
      if (this.drugItems.length === 0) {
        this.$message.warning('没有可退药品');
        return;
      }

      // 2. 判断是否所有项目都是未发药状态（dispensed === false）
      const allNotDispensed = this.drugItems.every(item => item.dispensed === false);

      // ===== 情况一：全部未发药 → 直接走退款（chargesRefunds） =====
      if (allNotDispensed) {
        if (!this.returnReason.trim()) {
          this.$message.warning('请在下侧填写退款原因');
          return;
        }

        try {
          await this.$confirm('确认全退该订单所有未发药项目吗？', '全退确认', {
            confirmButtonText: '确认全退',
            cancelButtonText: '取消',
            type: 'warning'
          });
        } catch {
          return;
        }

        this.returnAllSubmitting = true;
        try {
          const items = this.drugItems.map(item => ({
            chargeItemId: item.chargeItemId,
            refundQty: item.refundableQty || 0,
          }));

          const payments = (this.detailData.payments || [])
              .filter(p => (p.refundableAmount || p.amount || 0) > 0)
              .map(p => ({
                originalPaymentId: p.originalPaymentId || p.id || 0,
                amount: p.refundableAmount || p.amount || 0
              }));

          const request = {
            chargeId: this.detailData.chargeId,
            items: items,
            payments: payments,
            reason: this.returnReason.trim(),
            requestNo: this.generateUUID()
          };

          const res = await chargesRefunds(request);
          if (res.code === 200) {
            this.$message.success('全退成功');

            // ===== 未发药全退：不刷新左侧表格，直接关闭弹窗并刷新列表 =====
            this.batchDetailData = [];
            this.selectedDrugName = '';
            this.selectedOrderItemId = null;
            this.selectedOrderId = null;

            // 刷新主列表
            await this.loadData();

            // 关闭弹窗
            this.detailDialogVisible = false;
          } else {
            this.$message.error(res.message || '全退失败');
          }
        } catch (error) {
          console.error('全退失败:', error);
          this.$message.error('全退失败，请重试');
        } finally {
          this.returnAllSubmitting = false;
        }
        return;
      }

      // ===== 情况二：存在已发药 → 走退药流程 =====
      const firstItem = this.drugItems[0];
      const orderItemId = firstItem.orderItemId;

      if (!orderItemId) {
        this.$message.error('未找到订单明细ID');
        return;
      }

      if (!this.returnReason.trim()) {
        this.$message.warning('请在下侧填写退药原因');
        return;
      }

      try {
        await this.$confirm('确认全退该订单所有药品吗？', '全退确认', {
          confirmButtonText: '确认全退',
          cancelButtonText: '取消',
          type: 'warning'
        });
      } catch {
        return;
      }

      this.returnAllSubmitting = true;
      try {
        const params = {
          outpOrderItemId: orderItemId,
          reason: this.returnReason.trim(),
          requestNo: this.generateUUID(),
          returnType: this.returnType
        };

        const res = await submitReturnDrugDetailAll(params);
        if (res.code === 200) {
          this.$message.success('全退成功');

          // ===== 已发药：需要刷新左侧表格（可退数量会变化） =====
          await this.refreshLeftTable();

          // 刷新右侧批次数据
          if (this.selectedOrderItemId) {
            await this.getDrugItemsDetail({
              orderItemId: this.selectedOrderItemId,
              itemName: this.selectedDrugName,
              dispensed: true
            });
          }

          // 重置输入
          this.batchDetailData.forEach(item => {
            item.returnCnt = 0;
            (item.selectedBars || []).forEach(bar => {
              bar.checked = false;
              bar.returnCnt = 0;
            });
          });

          // 刷新主列表
          await this.loadData();
        } else {
          this.$message.error(res.message || '全退失败');
        }
      } catch (error) {
        console.error('全退失败:', error);
        this.$message.error('全退失败，请重试');
      } finally {
        this.returnAllSubmitting = false;
      }
    },    // ===== 计算已退药数量 =====
    getReturnTotal(returnItems) {
      if (!returnItems || returnItems.length === 0) return 0;
      return returnItems.reduce((sum, item) => sum + (item.returnQty || 0), 0);
    },

    // ===== 计算实际可退数量 =====
    getActualRefundableQty(row) {
      const returnTotal = this.getReturnTotal(row.returnItems);
      return Math.max(0, (row.refundableQty || 0) - returnTotal);
    },

    // ===== 展开行变化 =====
    handleDrugExpandChange(row, expandedRows) {
      this.drugReturnExpand = expandedRows.map(r => r.chargeItemId);
    },

    // ===== 追溯码选择变化 =====
    handleBarSelectionChange(row, selection) {
      // 将选中状态同步到 row.selectedBars
      row.selectedBars.forEach(bar => {
        bar.checked = selection.some(s => s.barcode === bar.barcode);
      });

      const limit = row.returnCnt || 0;
      const checkedBars = row.selectedBars.filter(bar => bar.checked);
      if (checkedBars.length > limit) {
        // 超出限制，自动取消最后勾选的（或最早勾选的），这里简单截断：只保留前 limit 个
        // 但 selection 是数组，我们可以反向操作，但更简单的是重新设置勾选
        // 这里我们选择提示并自动取消多余的勾选
        this.$message.warning(`最多只能勾选 ${limit} 个追溯码`);
        // 将多余取消勾选
        const surplus = checkedBars.slice(limit);
        surplus.forEach(bar => bar.checked = false);
        // 重新设置 selection（但需要触发表格更新，可以使用 this.$refs 重新设置）
        // 由于我们修改了 bar.checked，但表格的selection状态不同步，需要手动清除并重新设置
        // 更稳妥的方法：使用 this.$nextTick 重新触发表格选择
        this.$nextTick(() => {
          // 找到当前批次对应的展开行表格 ref，但展开行多，不好直接获取，我们可以通过数据驱动
          // 简单做法：重新赋值 selectedBars 触发更新，或调用表格的 clearSelection 再设置
          // 这里我们利用 row.selectedBars 的变化，但表格的selection不会自动更新，需要手动干预
          // 这里可以用一个技巧：将 row.selectedBars 重新赋值触发渲染
          row.selectedBars = row.selectedBars.map(bar => ({ ...bar }));
          // 然后重新设置勾选状态（只勾选前 limit 个）
          const newSelection = row.selectedBars.filter((_, index) => index < limit);
          // 但无法直接操作 el-table 的 selection，因此我们通过 $refs 查找表格
          // 由于展开行是动态的，最好通过 row 的标识找到对应的表格实例，比较麻烦
          // 建议：在 checkBarSelectable 中已经限制了勾选，所以正常情况下不会超过，
          // 如果用户先输入大数勾选多个，再改小输入框，此时需要处理。
          // 为了简化，我们可以在 returnCnt 变化时重置勾选。
        });
      }
    },

    // ===== 提交退药 =====
// ===== 提交退药 =====
    async handleSubmitReturnDrug() {
      // ==========================================================
      // 1. 中药特殊处理：不需要勾选追溯码，直接用 tcmRefundQty
      // ==========================================================
      if (this.prescriptionType === 'tcm') {
        if (this.tcmRefundQty <= 0) {
          this.$message.warning('请填写退回付数');
          return;
        }
        if (!this.returnReason.trim()) {
          this.$message.warning('请填写退药原因');
          return;
        }

        const tcmItems = this.tcmItemsData || [];
        if (tcmItems.length === 0) {
          this.$message.error('未找到中药数据');
          return;
        }

        const firstItem = tcmItems[0];
        const doseCount = firstItem.doseCount || 1;
        const perDoseQty = firstItem.chargedQty / doseCount;

        for (const item of tcmItems) {
          const itemPerDoseQty = item.chargedQty / (item.doseCount || 1);
          const itemReturnQty = this.tcmRefundQty * itemPerDoseQty;
          if (itemReturnQty > (item.refundableQty || 0)) {
            this.$message.warning(
                `「${item.itemName}」退药数量（${itemReturnQty}${item.unitName}）超过可退数量（${item.refundableQty}${item.unitName}）`
            );
            return;
          }
        }

        try {
          await this.$confirm(
              `确认退药 ${this.tcmRefundQty} 付（共 ${tcmItems.length} 味药）吗？`,
              '提示',
              {
                confirmButtonText: '确认提交',
                cancelButtonText: '取消',
                type: 'warning',
              }
          );
        } catch {
          return;
        }

        this.returnSubmitting = true;
        try {
          const list = tcmItems.map((item) => {
            const itemPerDoseQty = item.chargedQty / (item.doseCount || 1);
            const itemReturnQty = this.tcmRefundQty * itemPerDoseQty;
            return {
              orderItemId: item.orderItemId,
              returnCnt: itemReturnQty,
            };
          });

          const request = {
            list: list,
            reason: this.returnReason.trim(),
            requestNo: this.generateUUID(),
            returnType: this.returnType,
          };

          const res = await submitReturnDrugDetailTcm(request);
          if (res.code === 200) {
            this.$message.success('退药成功');
            await this.refreshLeftTable();

            if (this.currentOrderItemId) {
              delete this.batchDetailCache[this.currentOrderItemId];
              const currentItem = this.drugItems.find(
                  (item) => item.orderItemId === this.currentOrderItemId
              );
              if (currentItem) {
                await this.getDrugItemsDetail(currentItem);
              } else {
                if (this.drugItems.length > 0) {
                  await this.getDrugItemsDetail(this.drugItems[0]);
                } else {
                  this.batchDetailData = [];
                  this.selectedDrugName = '';
                }
              }
            }

            this.batchDetailData = [];
            this.selectedDrugName = '中药无需查看批次明细';
            this.selectedOrderItemId = null;
            this.selectedOrderId = null;
            await this.loadData();
          } else {
            this.$message.error(res.message || '退药失败');
          }
        } catch (error) {
          console.error('退药失败:', error);
          this.$message.error('退药失败，请重试');
        } finally {
          this.returnSubmitting = false;
        }
        return;
      }

      // ==========================================================
      // 2. 非中药（西药/输液）处理
      // ==========================================================
      const submitList = [];
      let orderId = null;

      // 遍历缓存中所有药品的批次数据
      for (const key in this.batchDetailCache) {
        const batches = this.batchDetailCache[key];
        if (!batches || batches.length === 0) continue;

        if (!orderId) {
          orderId = batches[0].orderId;
        }

        for (const item of batches) {
          // ===== 情况1：有追溯码，必须勾选至少一个 =====
          if (item.barList && item.barList.length > 0) {
            const checkedBars = (item.selectedBars || []).filter(bar => bar.checked);
            if (checkedBars.length === 0) continue; // 未勾选，跳过

            const barList = checkedBars.map(bar => ({
              barcode: bar.barcode,
              chgCnt: bar.outCnt
            }));

            submitList.push({
              dispenseItemId: item.dispenseItemId,
              returnCnt: item.returnCnt,
              tracCodeJson: JSON.stringify(barList),
            });
          }
          // ===== 情况2：无追溯码，只要 returnCnt > 0 即可提交 =====
          else {
            if (item.returnCnt > 0) {
              submitList.push({
                dispenseItemId: item.dispenseItemId,
                returnCnt: item.returnCnt,
                tracCodeJson: null,
              });
            }
          }
        }
      }

      // 校验
      if (submitList.length === 0) {
        this.$message.warning('请至少填写一个批次的退药数量');
        return;
      }

      if (!this.returnReason.trim()) {
        this.$message.warning('请填写退药原因');
        return;
      }

      if (!orderId) {
        this.$message.error('未找到订单ID，请重新加载批次信息');
        return;
      }

      try {
        await this.$confirm('确认提交退药申请吗？', '提示', {
          confirmButtonText: '确认提交',
          cancelButtonText: '取消',
          type: 'warning',
        });
      } catch {
        return;
      }

      this.returnSubmitting = true;
      try {
        const request = {
          list: submitList,
          orderId: orderId,
          reason: this.returnReason.trim(),
          requestNo: this.generateUUID(),
          returnType: this.returnType,
        };

        const res = await submitReturnDrugDetail(request);

        if (res.code === 200) {
          this.$message.success('退药成功');

          for (const key in this.batchDetailCache) {
            this.batchDetailCache[key].forEach((item) => {
              item.returnCnt = 0;
              (item.selectedBars || []).forEach((bar) => {
                bar.checked = false;
                bar.returnCnt = 0;
              });
            });
          }
          if (this.currentOrderItemId && this.batchDetailCache[this.currentOrderItemId]) {
            this.batchDetailData = this.batchDetailCache[this.currentOrderItemId];
          }

          await this.refreshLeftTable();

          if (this.currentOrderItemId) {
            delete this.batchDetailCache[this.currentOrderItemId];
            const currentItem = this.drugItems.find(
                (item) => item.orderItemId === this.currentOrderItemId
            );
            if (currentItem) {
              await this.getDrugItemsDetail(currentItem);
            } else {
              if (this.drugItems.length > 0) {
                await this.getDrugItemsDetail(this.drugItems[0]);
              } else {
                this.batchDetailData = [];
                this.selectedDrugName = '';
              }
            }
          }

          await this.loadData();
        } else {
          this.$message.error(res.message || '退药失败');
        }
      } catch (error) {
        console.error('退药失败:', error);
        this.$message.error('退药失败，请重试');
      } finally {
        this.returnSubmitting = false;
      }
    },
// ===== 刷新左侧表格（提取公共方法） =====
    async refreshLeftTable() {
      const chargeId = this.detailData.chargeId;
      if (!chargeId) return;

      try {
        const refreshRes = await getRefundableCharges({ chargeId: chargeId });
        if (refreshRes.code === 200) {
          const data = refreshRes.data;
          this.detailData.items = data.items || [];
          this.detailData.refundableAmount = data.refundableAmount || 0;
          this.detailData.refundedAmount = data.refundedAmount || 0;
          this.drugItems = data.items.filter(item => [1, 2, 5, 6].includes(item.itemType));
          this.treatmentItems = data.items.filter(item => [4, 7, 8].includes(item.itemType));

          if (this.prescriptionType === 'tcm') {
            const tcmItems = data.items.filter(item => item.itemType === 2);
            const firstItem = tcmItems[0] || {};

            const doseCount = firstItem.doseCount || 1;
            const perDoseQty = firstItem.chargedQty / doseCount;

            // 已退药付数
            let totalReturnQty = 0;
            if (firstItem.returnItems && firstItem.returnItems.length > 0) {
              firstItem.returnItems.forEach(item => {
                totalReturnQty += item.returnQty || 0;
              });
            }
            const returnedPacks = totalReturnQty / perDoseQty;

            // 已退费/可退费付数
            const refundedPacks = (firstItem.refundedQty || 0) / perDoseQty;
            const refundablePacks = (firstItem.refundableQty || 0) / perDoseQty;

            this.tcmTotalPacks = doseCount;
            this.tcmTotalQty = firstItem.chargedQty || 0;
            this.tcmUnit = firstItem.unitName || 'g';

            this.tcmReturnedPacks = returnedPacks;
            this.tcmRefundableReturnPacks = doseCount - returnedPacks;

            this.tcmRefundedPacks = refundedPacks;
            this.tcmRefundablePacks = refundablePacks;

            this.tcmItemCount = tcmItems.length;
            this.tcmItemsData = tcmItems;
          }

          // 更新选中状态
          const currentSelectedIds = this.selectedItems.map(item => item.chargeItemId);
          this.selectedItems = this.detailData.items.filter(item =>
              currentSelectedIds.includes(item.chargeItemId) &&
              (item.refundableQty || 0) > 0 &&
              (item.refundableAmount || 0) > 0
          );
        }
      } catch (error) {
        console.error('刷新左侧表格失败:', error);
      }
    },
    async getDrugItemsDetail(row) {
      if (!row || !row.orderItemId) {
        this.$message.warning('暂无批次信息');
        return;
      }

      const key = row.orderItemId;

      // 保存当前显示的数据到缓存（如果存在且与当前key不同）
      if (this.currentOrderItemId && this.currentOrderItemId !== key) {
        this.batchDetailCache[this.currentOrderItemId] = this.batchDetailData;
      }

      // 切换到新药品
      this.currentOrderItemId = key;
      this.selectedDrugName = row.itemName || '未知药品';
      this.selectedOrderId = row.orderId || null;

      // 如果缓存中有该药品数据，直接显示
      if (this.batchDetailCache[key]) {
        this.batchDetailData = this.batchDetailCache[key];
        return;
      }

      // 否则请求数据
      this.batchLoading = true;
      try {
        const res = await getReturnDrugDetail({ orderItemId: key });
        if (res.code === 200) {
          const data = (res.data || []).map(item => ({
            ...item,
            returnCnt: 0,
            selectedBars: item.barList && item.barList.length > 0
                ? item.barList.map(bar => ({
                  ...bar,
                  checked: false,
                  returnCnt: 0
                }))
                : []
          }));
          // 存入缓存并显示
          this.batchDetailCache[key] = data;
          this.batchDetailData = data;
          if (data.length === 0) {
            this.$message.info('该药品暂无批次信息');
          }
        } else {
          this.$message.error(res.message || '加载批次信息失败');
          this.batchDetailCache[key] = [];
          this.batchDetailData = [];
        }
      } catch (error) {
        console.error('加载批次信息失败:', error);
        this.$message.error('加载批次信息失败，请重试');
        this.batchDetailCache[key] = [];
        this.batchDetailData = [];
      } finally {
        this.batchLoading = false;
      }
    },    async loadPaymentMethods() {
      try {
        const res = await getPatternPaymentList();
        if (res.code === 200) {
          this.paymentMethods = res.data;
        }
      } catch (error) {
        console.error('加载支付方式失败:', error);
      }
    },

    getPayWayLabel(payWayId) {
      const method = this.paymentMethods.find(item => item.id === payWayId);
      return method?.wayName || `支付方式(${payWayId})`;
    },

    handleSearch() {
      this.pageNum = 1;
      this.loadData();
    },

    handleReset() {
      this.searchForm = {
        chargeNo: '',
        patientName: '',
        chargeType: null,
        status: null,
        timeRange: [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ]
      };
      this.pageNum = 1;
      this.loadData();
    },

    handleRefresh() {
      this.loadData();
    },

    async loadData() {
      this.loading = true;
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          chargeNo: this.searchForm.chargeNo || undefined,
          patientName: this.searchForm.patientName || undefined,
          chargeType: this.searchForm.chargeType || undefined,
          status: this.searchForm.status || undefined,
          startTime: this.searchForm.timeRange?.[0] || undefined,
          endTime: this.searchForm.timeRange?.[1] || undefined
        };

        const res = await getChargesQuery(params);
        if (res.code === 200) {
          this.tableData = res.data?.content || [];
          this.totalSize = res.data?.totalSize || 0;
        } else {
          this.$message.error(res.message || '查询失败');
        }
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$message.error('加载数据失败，请重试');
      } finally {
        this.loading = false;
      }
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.loadData();
    },

    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    handleCancelOrder(row) {
      this.$confirm(
          `确认作废订单「${row.chargeNo}」吗？作废后不可恢复！`,
          '提示',
          {
            confirmButtonText: '确认作废',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(async () => {
        try {
          const res = await cancelOrderById(row.id, { cancelReason: '患者要求作废' });
          if (res.code === 200) {
            this.$message.success('作废成功');
            this.loadData();
          } else {
            this.$message.error(res.message || '作废失败');
          }
        } catch (error) {
          console.error('作废失败:', error);
          this.$message.error('作废失败，请重试');
        }
      }).catch(() => {});
    },

    async handleRowClick(row) {
      if (!row) return;

      if (this.detailDialogVisible) {
        this.detailDialogVisible = false;
        await this.$nextTick();
      }

      this.detailDialogVisible = true;
      this.detailLoading = true;
      this.selectedItems = [];

      this.tcmTotalPacks = 0;
      this.tcmRefundedPacks = 0;
      this.tcmRefundablePacks = 0;
      this.tcmRefundQty = 0;
      this.tcmRefundAmount = 0;
      this.tcmItemCount = 0;
      this.treatmentItems = [];
      this.drugItems = [];

      try {
        const res = await getRefundableCharges({ chargeId: row.id });
        if (res.code === 200) {
          const data = res.data;
          this.detailData = {
            chargeId: data.chargeId,
            chargeNo: data.chargeNo,
            patientName: data.patientName,
            chargeTime: data.chargeTime,
            status: data.status,
            refundableAmount: data.refundableAmount || 0,
            refundedAmount: data.refundedAmount || 0,
            items: data.items || [],
            payments: data.payments || []
          };
          this.prescriptionType = this.getPrescriptionType(data.items);
          this.treatmentItems = data.items.filter(item => [4, 7, 8].includes(item.itemType));
          this.drugItems = data.items.filter(item => [1, 2, 5, 6].includes(item.itemType));

          if (this.prescriptionType === 'tcm') {
            const tcmItems = data.items.filter(item => item.itemType === 2);
            const firstItem = tcmItems[0] || {};

            const doseCount = firstItem.doseCount || 1;              // 3付
            const perDoseQty = firstItem.chargedQty / doseCount;     // 5g/付

            // ---------- 已退药付数（从 returnItems 累加） ----------
            let totalReturnQty = 0;
            if (firstItem.returnItems && firstItem.returnItems.length > 0) {
              firstItem.returnItems.forEach(item => {
                totalReturnQty += item.returnQty || 0;
              });
            }
            const returnedPacks = totalReturnQty / perDoseQty;       // 10/5 = 2付（退药）

            // ---------- 已退费付数（refundedQty） ----------
            const refundedPacks = (firstItem.refundedQty || 0) / perDoseQty;  // 0/5 = 0付（退费）

            // ---------- 可退费付数（refundableQty） ----------
            const refundablePacks = (firstItem.refundableQty || 0) / perDoseQty;  // 15/5 = 3付

            // ---------- 赋值 ----------
            this.tcmTotalPacks = doseCount;                                     // 3付
            this.tcmTotalQty = firstItem.chargedQty || 0;                     // 15g
            this.tcmUnit = firstItem.unitName || 'g';

            this.tcmReturnedPacks = returnedPacks;                            // 2付（已退药）
            this.tcmRefundableReturnPacks = doseCount - returnedPacks;        // 1付（可退药）

            this.tcmRefundedPacks = refundedPacks;                            // 0付（已退费）
            this.tcmRefundablePacks = refundablePacks;                        // 3付（可退费）

            this.tcmItemCount = tcmItems.length;
            this.tcmRefundQty = 0;
            this.tcmDisposalMethod = 'DESTROY';
            this.tcmItemsData = tcmItems;

            this.batchDetailData = [];
            this.selectedDrugName = '中药无需查看批次明细';
            this.selectedOrderItemId = null;
            this.selectedOrderId = null;
          } else {
          if (['western', 'infusion', 'mixed'].includes(this.prescriptionType)) {
            const firstDrug = this.drugItems.find(item => item.orderItemId && item.itemType !== 2);
            if (firstDrug && firstDrug.orderItemId) {
              this.$nextTick(() => {
                this.getDrugItemsDetail(firstDrug);
              });
            }
          }
        }
          this.$nextTick(() => {
            this.calcTableHeight();
          });
        } else {
          this.$message.error(res.message || '加载可退数据失败');
          this.detailDialogVisible = false;
        }
      } catch (error) {
        console.error('加载可退数据失败:', error);
        this.$message.error('加载可退数据失败，请重试');
        this.detailDialogVisible = false;
      } finally {
        this.detailLoading = false;
      }
    },
    handleDetailClosed() {
      this.detailData = {
        chargeId: null,
        chargeNo: '',
        patientName: '',
        chargeTime: '',
        status: null,
        refundableAmount: 0,
        refundedAmount: 0,
        items: [],
        payments: [],
      };
      this.batchDetailCache = {};
      this.currentOrderItemId = null;
      this.tcmItemsData = [];
      this.drugReturnExpand = [];
      this.batchDetailData = [];
      this.selectedDrugName = '';
      this.selectedOrderItemId = null;
      this.selectedOrderId = null;
      this.returnReason = '';
      this.returnType = 1;
      this.selectedItems = [];
      this.treatmentItems = [];
      this.drugItems = [];
      this.prescriptionType = 'other';
      this.tcmRefundQty = 0;
    },

    getPrescriptionType(items) {
      if (!items || items.length === 0) return 'other';

      const types = new Set(items.map(item => item.itemType));
      const hasDrug = types.has(1) || types.has(2) || types.has(5) || types.has(6);
      const hasTreatment = types.has(4) || types.has(7) || types.has(8);
      const hasTcm = types.has(2);
      const hasInfusion = types.has(6);
      const hasWestern = types.has(1) || types.has(5);

      if (hasDrug && hasTreatment) return 'mixed';
      if (hasTcm && !hasWestern && !hasInfusion) return 'tcm';
      if (hasInfusion && !hasWestern && !hasTreatment) return 'infusion';
      if (hasWestern && !hasInfusion && !hasTreatment) return 'western';
      if (hasTreatment && !hasDrug) return 'treatment';
      if (hasInfusion && hasWestern) return 'infusion';
      return 'other';
    },

    getPrescriptionTypeLabel(type) {
      const map = {
        'western': '西药处方',
        'tcm': '中药处方',
        'infusion': '输液处方',
        'treatment': '处置处方',
        'mixed': '混合处方',
        'other': '其他'
      };
      return map[type] || '其他';
    },

    getStatusType(status) {
      const map = { 1: 'success', 2: 'warning', 3: 'danger' };
      return map[status] || 'info';
    },

    getStatusLabel(status) {
      const map = { 1: '已收费', 2: '部分退款', 3: '全额退款' };
      return map[status] || '未知';
    },

    getItemTypeLabel(type) {
      const map = {
        1: '西药',
        2: '中药',
        4: '理疗',
        5: '卫材',
        6: '输液/治疗',
        7: '检查',
        8: '检验',
        9: '挂号费',
        10: '其他'
      };
      return map[type] || '其他';
    },

    checkSelectable(row) {
      return (row.refundableQty || 0) > 0 && (row.refundableAmount || 0) > 0;
    },

    checkTreatmentSelectable(row) {
      return (row.refundableQty || 0) > 0 && (row.refundableAmount || 0) > 0;
    },

    checkDrugSelectable(row) {
      // 已执行西药不可选
/*
      if (row.executedQty >= 1 && row.itemType === 1) return false;
*/
      // 只要可退金额 > 0 就能勾选（退钱和退药是分离的）
      return (row.refundableAmount || 0) > 0;
    },

    handleItemSelectionChange(selection) {
      this.selectedItems = selection;
    },

    handleTreatmentSelectionChange(selection) {
      const drugSelection = this.$refs.drugTable ? this.$refs.drugTable.selection : [];
      this.selectedItems = [...selection, ...drugSelection];
    },

    handleDrugSelectionChange(selection) {
      const treatmentSelection = this.$refs.treatmentTable ? this.$refs.treatmentTable.selection : [];
      this.selectedItems = [...treatmentSelection, ...selection];
    },

    handleItemRowClick(row) {
      if (this.checkSelectable(row)) {
        this.$refs.itemTable.toggleRowSelection(row);
      }
    },

    handleTcmRefundChange() {
      const tcmItem = this.detailData.items.find(item => item.itemType === 2);
      if (tcmItem) {
        const unitPrice = tcmItem.paidAmount / (tcmItem.chargedQty || 1);
        this.tcmRefundAmount = this.tcmRefundQty * unitPrice;
      }
    },

    getTotalRefundableAmount() {
      if (this.prescriptionType === 'tcm') {
        const tcmItem = this.detailData.items.find(item => item.itemType === 2);
        if (tcmItem) {
          return tcmItem.refundableAmount || 0;
        }
        return 0;
      }
      let total = 0;
      this.selectedItems.forEach(item => {
        total += item.refundableAmount || 0;
      });
      return total;
    },

// ================================================================
// 打开退款弹窗
// ================================================================
    handleOpenRefundDialog() {
      // ===== 1. 中药特殊处理 =====
// ===== 1. 中药特殊处理 =====
      this.refundReason = this.returnReason;
      if (this.prescriptionType === 'tcm') {
        // 获取所有中药
        const tcmItems = this.detailData.items.filter(item => item.itemType === 2);
        if (tcmItems.length === 0) {
          this.$message.warning('未找到中药数据');
          this.refundItems = [];
          this.buildRefundPayments();
          this.refundDialogVisible = true;
          return;
        }

        // 使用第一个药计算已退付数（所有药付数一致）
        const firstItem = tcmItems[0];
        const perDoseQty = firstItem.chargedQty / (firstItem.doseCount || 1);
        const returnTotal = this.getReturnTotal(firstItem.returnItems);
        const refundPacks = returnTotal / perDoseQty;  // 已退付数

        if (refundPacks <= 0) {
          this.$message.info('当前没有可退药记录，退款数量为0');
          this.refundItems = [];
          this.buildRefundPayments();
          this.refundDialogVisible = true;
          return;
        }

        // ⭐ 遍历所有中药，每个药味单独构建退款项
        this.refundItems = tcmItems.map(item => {
          const itemPerDose = item.chargedQty / (item.doseCount || 1);
          const itemReturnTotal = this.getReturnTotal(item.returnItems);
          const itemRefundPacks = itemReturnTotal / itemPerDose;  // 该药已退付数

          const unitPrice = item.unitPrice || (item.paidAmount / (item.chargedQty || 1));
          const refundAmount = itemRefundPacks * itemPerDose * unitPrice;

          return {
            chargeItemId: item.chargeItemId,
            itemName: item.itemName || '中药',
            specification: item.specification || '-',
            unitName: item.unitName || 'g',
            chargedQty: item.chargedQty || 0,
            refundableQty: this.tcmRefundablePacks || 0,
            refundQty: itemRefundPacks,   // 该药已退付数
            refundAmount: Math.min(refundAmount, item.refundableAmount || 0),
            unitPrice: unitPrice,
            paidAmount: item.paidAmount || 0,
            refundedAmount: item.refundedAmount || 0,
            _raw: item
          };
        });

        this.buildRefundPayments();
        this.refundDialogVisible = true;
        this.$nextTick(() => {
          this.distributeRefundAmountToPayments();
        });
        return;
      }
      // ===== 2. 非中药：正常逻辑 =====
      if (this.selectedItems.length === 0) {
        this.$message.info('未选择退款项目，将显示空数据');
        this.refundItems = [];
        this.buildRefundPayments();
        this.refundDialogVisible = true;
        return;
      }

      this.refundItems = this.selectedItems.map(selected => {
        const fullItem = this.detailData.items.find(item => item.chargeItemId === selected.chargeItemId);
        const item = fullItem || selected;

        const unitPrice = item.unitPrice || (item.paidAmount / (item.chargedQty || 1));
        const isTreatment = [4, 5, 7, 8].includes(item.itemType);

        let refundQty = 0;
        let refundAmount = 0;

        if (isTreatment) {
          // 处置项目：直接退可退数量和金额
          refundQty = item.refundableQty || 0;
          refundAmount = item.refundableAmount || 0;
        } else {
          // 药品项目：基于 returnItems 累加已退药数量
          const returnTotal = this.getReturnTotal(item.returnItems);
          refundQty = returnTotal;
          refundAmount = refundQty * unitPrice;
        }

        return {
          chargeItemId: item.chargeItemId,
          itemName: item.itemName,
          specification: item.specification,
          unitName: item.unitName || '个',
          chargedQty: item.chargedQty || 0,
          refundableQty: item.refundableQty || 0,
          refundQty: refundQty,
          refundAmount: Math.min(refundAmount, item.refundableAmount || 0),
          unitPrice: unitPrice,
          paidAmount: item.paidAmount || 0,
          refundedAmount: item.refundedAmount || 0,
          _raw: item
        };
      });
      console.log(this.refundItems,'this.refundItemsthis.refundItems')
// 过滤掉退款数量为 0 的项目
      this.refundItems = this.refundItems.filter(item => item.refundQty > 0);

      if (this.refundItems.length === 0) {
        this.$message.info('所选项目无可退数量');
        this.refundItems = [];
        this.buildRefundPayments();
        this.refundDialogVisible = true;
        return;
      }

      this.buildRefundPayments();
      this.refundDialogVisible = true;
      this.$nextTick(() => {
        this.distributeRefundAmountToPayments();
      });
    },
    buildRefundPayments() {
      const allPayments = this.detailData.payments || [];

      console.log('===== allPayments =====', allPayments);

      if (allPayments.length === 0) {
        this.$message.warning('没有可退款的支付方式');
        this.refundPayments = [];
        return;
      }

      this.refundPayments = allPayments
          .filter(p => {
            const refundable = p.refundableAmount || p.amount || 0;
            return refundable > 0;
          })
          .map(p => {
            const refundable = p.refundableAmount || p.amount || 0;
            return {
              payWayId: p.payWayId,
              amount: p.paidAmount || p.amount || 0,
              refundedAmount: p.refundedAmount || 0,
              refundableAmount: refundable,
              refundAmount: 0,
              originalPaymentId: p.originalPaymentId || p.id || 0,
              ids: [p.originalPaymentId || p.id || 0]
            };
          });

      console.log('===== refundPayments =====', this.refundPayments);
    },
    handleRefundQtyChange(row) {
      const qty = row.refundQty || 0;
      const unitPrice = row.unitPrice || 0;
      const calculated = qty * unitPrice;
      row.refundAmount = Math.min(calculated, row.refundableAmount || 0);
      this.distributeRefundAmountToPayments();
    },

    distributeRefundAmountToPayments() {
      const totalRefund = this.refundItems.reduce((sum, item) => sum + (item.refundAmount || 0), 0);

      this.refundPayments.forEach(p => {
        p.refundableAmount = (p.amount || 0) - (p.refundedAmount || 0);
      });

      if (totalRefund <= 0) {
        this.refundPayments.forEach(p => p.refundAmount = 0);
        return;
      }

      const availablePayments = this.refundPayments.filter(p => p.refundableAmount > 0);

      if (availablePayments.length === 1) {
        const payment = availablePayments[0];
        payment.refundAmount = Math.min(totalRefund, payment.refundableAmount);
      } else {
        this.refundPayments.forEach(p => p.refundAmount = 0);
      }
    },

    handlePaymentRefundChange() {},

    getRefundTotal() {
      return this.refundItems.reduce((sum, item) => sum + (item.refundAmount || 0), 0);
    },

    async handleConfirmRefund() {
      const emptyItems = this.refundItems.filter(item => !item.refundQty || item.refundQty <= 0);
      if (emptyItems.length > 0) {
        this.$message.warning('请为所有项目填写退款数量');
        return;
      }

      const totalRefund = this.getRefundTotal();
      if (totalRefund <= 0) {
        this.$message.warning('退款金额不能为0');
        return;
      }

      const paymentTotal = this.refundPayments.reduce((sum, p) => sum + (p.refundAmount || 0), 0);
      if (Math.abs(paymentTotal - totalRefund) > 0.01) {
        this.$message.warning('退款金额与支付方式分配金额不一致，请调整');
        return;
      }

      if (!this.refundReason.trim()) {
        this.$message.warning('请填写退款原因');
        return;
      }

      this.refundLoading = true;
      try {
        const items = this.refundItems.map(item => {
          const fullItem = this.detailData.items.find(i => i.chargeItemId === item.chargeItemId);

          let actualRefundQty = item.refundQty;
          if (fullItem?.itemType === 2) {
            const perDoseQty = fullItem.chargedQty / (fullItem.doseCount || 1);
            actualRefundQty = item.refundQty * perDoseQty;
          }

          const returnItems = (fullItem?.returnItems || []).map(ri => ({
            drugReturnItemId: ri.drugReturnItemId,
            allocatedQty: ri.returnQty || 0
          }));

          const requestItem = {
            chargeItemId: item.chargeItemId,
            refundQty: actualRefundQty,
            returnItems: returnItems.length > 0 ? returnItems : undefined
          };

          // ★ 如果有执行计划，携带 executionRefundQty（值为 refundableExecutionQty）
          if (fullItem && fullItem.totalExecutionQty > 0) {
            requestItem.executionRefundQty = fullItem.refundableExecutionQty || 0;
          }

          return requestItem;
        });

        const payments = this.refundPayments
            .filter(p => (p.refundAmount || 0) > 0)
            .map(p => ({
              originalPaymentId: p.originalPaymentId,
              amount: p.refundAmount || 0
            }));

        const request = {
          chargeId: this.detailData.chargeId,
          items: items,
          payments: payments,
          reason: this.refundReason.trim(),
          requestNo: this.generateUUID()
        };

        const res = await chargesRefunds(request);
        if (res.code === 200) {
          this.$message.success('退款成功');
          this.refundDialogVisible = false;
          this.detailDialogVisible = false;
          await this.loadData();
        } else {
          this.$message.error(res.message || '退款失败');
        }
      } catch (error) {
        console.error('退款失败:', error);
        this.$message.error('退款失败，请重试');
      } finally {
        this.refundLoading = false;
      }
    },
    handleRefundDialogClosed() {
      this.refundItems = [];
      this.refundPayments = [];
      this.refundReason = '';
    },

    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.mixed-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;

  /deep/ .el-tabs__header {
    flex-shrink: 0;
    margin: 0;
    background: #f8f9fa;
  }

  /deep/ .el-tabs__content {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;

    .el-tab-pane {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  }
}
.drug-table-wrap {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /deep/ .el-table {
    flex: 1;
    width: 100%;
    min-height: 0;

    .el-table__body-wrapper {
      overflow-y: auto !important;
    }
  }
}
.tcm-refund-area {
  padding: 20px 16px;
  background: #fafbfc;
  border-radius: 4px;
  height: calc(100% - 70px);
  display: flex;
  flex-direction: column;
  align-items: center;        // 水平居中
  justify-content: center;    // 垂直居中
  overflow-y: auto;

  /deep/ .el-form {
    width: 80%;
    max-width: 700px;
    // 让表单本身居中
    margin: 0 auto;
  }

  /deep/ .el-form-item {
    margin-bottom: 18px;
  }
  /deep/ .el-form-item__label {
    font-size: 14px;
    font-weight: 500;
  }

  // 折叠面板样式
  /deep/ .el-collapse {
    border: none;
    .el-collapse-item {
      border: none;
      .el-collapse-item__header {
        background: transparent;
        border: none;
        height: 32px;
        line-height: 32px;
        font-size: 13px;
        color: #409EFF;
        padding-left: 0;
      }
      .el-collapse-item__wrap {
        border: none;
        background: transparent;
        .el-collapse-item__content {
          padding: 0;
        }
      }
    }
  }
}
// ===== 追溯码折叠面板样式 =====
.bar-collapse {
  border: none !important;

  /deep/ .el-collapse-item {
    border: none !important;

    .el-collapse-item__header {
      background: transparent;
      border: none;
      height: 28px;
      line-height: 28px;
      font-size: 12px;
      color: #409EFF;
      padding-left: 0;
      justify-content: center;

      .el-collapse-item__arrow {
        margin: 0 4px 0 0;
      }
    }

    .el-collapse-item__wrap {
      border: none;
      background: transparent;

      .el-collapse-item__content {
        padding: 4px 0;

        .bar-list {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 4px;
          max-height: 120px;
          overflow-y: auto;
        }
      }
    }
  }
}
.history-charge {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: #f0f2f5;

  .search-bar {
    background: #fff;
    padding: 15px 20px;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    margin-bottom: 12px;

    /deep/ .el-form-item {
      margin-bottom: 6px;
    }
    /deep/ .el-form-item__label {
      font-size: 12px;
      padding-right: 6px;
    }
  }

  .table-container {
    flex: 1;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    padding: 4px 0 0 0;

    /deep/ .el-table__header-wrapper .el-table__header th {
      background-color: #f5f7fa;
      font-weight: 600;
    }
    /deep/ .cell {
      font-size: 12px;
    }
  }

  .pagination-container {
    background: #fff;
    padding: 10px 15px;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
  }
}

.detail-dialog {
  /deep/ .el-dialog__header {
    padding: 12px 20px;
    background-color: #007bb0;
    .el-dialog__title {
      color: #fff;
      font-size: 16px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }
  }

  /deep/ .el-dialog__body {
    padding: 10px 15px;
  }

  .detail-layout {
    height: 65vh;
    display: flex;
    flex-direction: column;

    .detail-header {
      background: #f8f9fa;
      border-radius: 4px;
      padding: 8px 12px;
      margin-bottom: 10px;
      border: 1px solid #e8ecf1;
      flex-shrink: 0;

      /deep/ .el-form-item {
        margin-bottom: 0;
      }
      /deep/ .el-form-item__label {
        font-size: 12px;
        padding-right: 4px;
      }
      /deep/ .el-input.is-disabled .el-input__inner {
        color: #303133;
        background-color: transparent;
        border: none;
        padding-left: 0;
      }
      /deep/ .el-tag {
        margin-top: 2px;
      }
    }

    .detail-body {
      flex: 1;
      display: flex;
      gap: 12px;
      min-height: 0;

      .detail-left {
        flex: 1;
        display: flex;
        flex-direction: column;
        border: 1px solid #e8ecf1;
        border-radius: 4px;
        overflow: hidden;
        min-width: 0;
        height: 100%;

        // 药品表格容器 - 让表格自动撑满
        .drug-table-wrap {
          flex: 1;
          min-height: 0;
          position: relative;   // 必须
          overflow: hidden;     // 防止溢出

          /deep/ .el-table {
            // 绝对定位由内联样式控制，这里只让 body-wrapper 滚动
            .el-table__body-wrapper {
              overflow-y: auto !important;
            }
          }
        }       // 展开内容样式 - 不加高度限制
        .drug-expand-content {
          background: #f5f7fa;

          .return-table-wrap {
            /deep/ .el-table {
              border-radius: 4px;
              .el-table__header-wrapper th {
                background-color: #e8ecf1;
                font-size: 12px;
              }
              .el-table__body-wrapper td {
                font-size: 12px;
              }
            }
          }

          .empty-return-tip {
            text-align: center;
            color: #C0C4CC;
            font-size: 12px;
            padding: 8px 0;
          }
        }
      }
      .detail-right {
        width: 35%;
        display: flex;
        flex-direction: column;
        border: 1px solid #e8ecf1;
        border-radius: 4px;
        overflow: hidden;
        min-width: 0;
        height: 100%;           // ← 撑满父容器

        .batch-table-wrapper {
          flex: 1;
          min-height: 0;
          position: relative;
          display: flex;
          flex-direction: column;

          /deep/ .el-table {
            height: 100% !important;

            .el-table__body-wrapper {
              height: calc(100% - 40px) !important;
              overflow-y: auto;
              overflow-x: auto;
            }
          }

          // ===== 底部退药操作栏 =====
          .return-action-bar {
            flex-shrink: 0;
            padding: 8px 12px;
            background: #f8f9fa;
            border-top: 1px solid #e8ecf1;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 8px;

            /deep/ .el-form-item {
              margin-bottom: 0;
              margin-right: 12px;
            }
            /deep/ .el-form-item__label {
              font-size: 12px;
              padding-right: 4px;
            }
            /deep/ .el-radio {
              margin-right: 12px;
            }
            /deep/ .el-radio__label {
              font-size: 12px;
            }
          }
        }

        // ===== 展开内容样式 =====
        .expand-content {
          background: #f5f7fa;

          .bar-table-wrap {
            /deep/ .el-table {
              border-radius: 4px;
              .el-table__header-wrapper th {
                background-color: #e8ecf1;
                font-size: 12px;
              }
              .el-table__body-wrapper td {
                font-size: 12px;
              }
            }
          }

          .empty-bar-tip {
            text-align: center;
            color: #C0C4CC;
            font-size: 12px;
            padding: 8px 0;
          }
        }

        .panel-title {
          padding: 6px 12px;
          background: #f8f9fa;
          border-bottom: 1px solid #e8ecf1;
          font-weight: bold;
          font-size: 14px;
          flex-shrink: 0;
        }

        // ===== 表格容器：撑满剩余高度 =====
        .batch-table-wrapper {
          flex: 1;
          min-height: 0;
          position: relative;

          /deep/ .el-table {
            height: 100% !important;

            .el-table__body-wrapper {
              height: calc(100% - 60px) !important;
              overflow-y: auto;   // 垂直滚动
              overflow-x: auto;   // 水平滚动
            }
          }
        }

        // ===== 空状态 =====
        .empty-tip {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #C0C4CC;

          p {
            margin: 0;
            font-size: 14px;
          }
        }

        // ===== 追溯码折叠面板样式 =====
        .bar-collapse {
          border: none !important;

          /deep/ .el-collapse-item {
            border: none !important;

            .el-collapse-item__header {
              background: transparent;
              border: none;
              height: 28px;
              line-height: 28px;
              font-size: 12px;
              color: #409EFF;
              padding-left: 0;
              justify-content: center;

              .el-collapse-item__arrow {
                margin: 0 4px 0 0;
              }
            }

            .el-collapse-item__wrap {
              border: none;
              background: transparent;

              .el-collapse-item__content {
                padding: 4px 0;

                .bar-list {
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: center;
                  gap: 4px;
                  max-height: 120px;
                  overflow-y: auto;
                }
              }
            }
          }
        }
      }
    }

    .common-return-bar {
      flex-shrink: 0;
      padding: 8px 16px;
      background: #f8f9fa;
      border: 1px solid #e8ecf1;
      border-radius: 4px;
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;

      /deep/ .el-form-item {
        margin-bottom: 0;
        margin-right: 12px;
      }
      /deep/ .el-form-item__label {
        font-size: 12px;
        padding-right: 4px;
      }
      /deep/ .el-radio {
        margin-right: 12px;
      }
      /deep/ .el-radio__label {
        font-size: 12px;
      }
      /deep/ .el-button {
        margin-left: 4px;
      }
    }
  }
}

.refund-dialog {
  /deep/ .el-dialog__header {
    padding: 12px 20px;
    background-color: #F56C6C;
    .el-dialog__title {
      color: #fff;
      font-size: 16px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }
  }

  .refund-content {
    /deep/ .el-form-item {
      margin-bottom: 8px;
    }
    /deep/ .el-form-item__label {
      font-size: 12px;
    }
    /deep/ .el-input-number {
      width: 130px;
    }
  }
}
</style>